<template>
  <div class="loading-area">
    <p>登入成功，請稍後 <i class="fas fa-spinner fa-pulse"></i></p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.loading-area {
  position: fixed;
  top: 55%;
  left: 50%;
  transform: translateX(-50%); /* 搭配 left:50% 可以置中 */

  background-color: #8d8d8d;
  z-index: 999;

  font-size: 22px;
  font-weight: bold;
  padding: 20px;
  opacity: 0.9;
  border-radius: 5px;
}

.loading-area p {
  color: white;
  margin-bottom: 0;
}
.loading-area p > i {
  margin-left: 10px;
}
</style>
